import React from 'react';

const Add = ({ className }) => {
    return (
        <svg width="43" height="43" viewBox="0 0 43 43" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="21.5" cy="21.5" r="21.5" fill="white" />
            <path d="M15 21.5H21.5M28 21.5H21.5M21.5 21.5V15V28" stroke="#B6B6B6" strokeWidth="3" strokeLinecap="round" />
        </svg>
    )
}

export default Add;